import dayjs from "dayjs";
import { HisDto } from "../export_spwk/HisDtoManager/HisDto";
import { Member } from "./Member";
import { MemberDAO } from "./MemberDAO";

export class His_Api {
  static REACT_APP_HIS_URL = process.env.REACT_APP_HIS_URL;
  static IHOSP = process.env.REACT_APP_IHOSP;

  static async 上傳Async(
    his_dto: HisDto,
    member: Member,
    IsGovCode: boolean,
    IsUiCode: boolean,
    IsHisCode: boolean
  ): Promise<any> {
    const apiUrl = His_Api.REACT_APP_HIS_URL + "/lab/labapi11/labapi11";
    let re: HisDto = { ...his_dto };
    for (let i = 0; i < re.問卷基礎.length; i++) {
      re.問卷基礎[i].目前從事結束日 = member.rec_dt;
    }
    re.問卷申報 = IsGovCode ? re.問卷申報 : [];
    re.問卷UI基礎 = IsUiCode
      ? re.問卷UI基礎
      : {
          曾經從事: "",
          曾經從事開始日: "",
          曾經從事結束日: "",
          目前從事: "",
          目前從事開始日: "",
          目前從事結束日: "",
          既往病歷1: "",
          既往病歷2: "",
          作業經歷: "",
          自覺症狀: "",
          既往病歷: "",
          ICD10: "",
        };
    re.問卷明細 = IsHisCode ? re.問卷明細 : [];
    let data = JSON.stringify(re, null, 4);
    const requestOptions: RequestInit = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
      mode: "cors",
    };
    try {
      let result = "";
      let message = "";
      if (His_Api.REACT_APP_HIS_URL === "https://intranet.chimei.org.tw") {
        const response = await fetch(apiUrl, requestOptions);
        const j = await response.json();
        const o = JSON.parse(j);
        result = o.結果;
        message = o.訊息內容;
        console.log(j, "json");
        console.log(o, "object");
        console.log(result, "結果");
        console.log(message, "訊息內容");
      } else {
        const response = await fetch(apiUrl, requestOptions);
        const j = await response.json();
        result = j.結果;
        message = j.訊息內容;
        console.log(j, "json");
        console.log(result, "結果");
        console.log(message, "訊息內容");
      }
      if (result === null || result === undefined) {
        alert("5478123 result不存在");
      } else if (result === "1") {
        if (dayjs(member.his_upload_dt).year() === 2999 && IsHisCode === true) {
          member.his_upload_dt = dayjs().format("YYYY/MM/DD HH:mm:ss");
          member.his_upload_err_msg = "";
          MemberDAO.Update_His(member);
        }
        if (dayjs(member.gov_upload_dt).year() === 2999 && IsGovCode === true) {
          member.gov_upload_dt = dayjs().format("YYYY/MM/DD HH:mm:ss");
          member.gov_upload_err_msg = "";
          MemberDAO.Update_Gov(member);
        }
        if (dayjs(member.ui_upload_dt).year() === 2999 && IsUiCode === true) {
          member.ui_upload_dt = dayjs().format("YYYY/MM/DD HH:mm:ss");
          member.ui_upload_err_msg = "";
          MemberDAO.Update_Ui(member);
        }
      } else if (result === "0") {
        const now = new Date();
        if (IsHisCode === true) {
          member.his_upload_err_msg = JSON.stringify({ now, message });
          member.his_upload_dt = "2999-01-01 00:00:00";
          MemberDAO.Update_His(member);
        }
        if (IsGovCode === true) {
          member.gov_upload_err_msg = JSON.stringify({ now, message });
          member.gov_upload_dt = "2999-01-01 00:00:00";
          MemberDAO.Update_Gov(member);
        }
        if (IsUiCode === true) {
          member.ui_upload_err_msg = JSON.stringify({ now, message });
          member.ui_upload_dt = "2999-01-01 00:00:00";
          MemberDAO.Update_Ui(member);
        }
        // alert(member.member_name + message)
      }
      return result;
    } catch (error) {
      console.error("API請求失敗", error);
      alert("API請求失敗" + error);
    }
  }

  // {
  //     "isn": "2303001700038"
  //     "ihosp":"院區"
  // }
  static async GetRealRecDt(member_code: string): Promise<any> {
    let data = JSON.stringify(
      { isn: member_code, ihosp: His_Api.IHOSP },
      null,
      4
    );

    const apiUrl =
      His_Api.REACT_APP_HIS_URL + "/lab/labapi03/labapi03/Registerday";
    const requestOptions: RequestInit = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: data,
      mode: "cors",
    };

    try {
      if (His_Api.REACT_APP_HIS_URL === "https://intranet.chimei.org.tw") {
        const response = await fetch(apiUrl, requestOptions);
        const j = await response.json();
        const o = JSON.parse(j);
        const result = o.結果;
        const message = o.訊息內容;
        const rec_dt = o.健檢日;
        console.log(j, "json");
        console.log(o, "object");
        console.log(result, "結果");
        console.log(message, "訊息內容");
        console.log(rec_dt, "健檢日");
        if (result === "1") {
          return rec_dt;
        } else {
          return "";
        }
      } else {
        const response = await fetch(apiUrl, requestOptions);
        const j = await response.json();
        console.log(j);
        if (j.結果 === "1") {
          return j.健檢日;
        } else {
          return "";
        }
      }
    } catch (error) {
      console.error("API請求失敗", error);
      return "";
    }
  }
}
